import { useColorMode, useColorStyle } from '@tonic-one/react';

const useCheckStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const checkedColorStyle = (
    {
      light: {
        color: colorStyle.color.success,
      },
      dark: {
        color: colorStyle.color.success,
      },
    } as any
  )[colorMode];
  const unCheckedColorStyle = (
    {
      light: {
        color: colorStyle.color.tertiary,
      },
      dark: {
        color: colorStyle.color.tertiary,
      },
    } as any
  )[colorMode];
  return {
    checked: checkedColorStyle,
    unChecked: unCheckedColorStyle,
  };
};
export { useCheckStyle };
